import { IntervalModel, IssueKeyType } from "model";

export function hasPriorReport(interval: IntervalModel) {
  return interval.issues.length > 0;
}

export function hasPriorReportType(interval: IntervalModel, key: IssueKeyType) {
  return interval.issues.some((item) => item.issueKey === key);
}

export function getPriorReport(interval: IntervalModel, key: IssueKeyType) {
  const indexOfIssue = interval.issues.findIndex((issue) => issue.issueKey === key);
  return interval.issues[indexOfIssue];
}
